import { normalize } from 'normalizr';
import deepStateMerge from '../../../../utils/deep-state-merge';
import { dataSchema } from './schemas';

export const normalizeAndMergeState = ({
  dataToNormalize = {},
  state,
  keysToExcludeFromMerge = [],
  keysToMergeArrays = [],
}) => {
  // MYBAG-4090: Cleanup - Start
  // Making a copy of the data so we can normalize it for our persisted f/offs schema
  if (dataToNormalize.fulfillmentOfferings) {
    dataToNormalize.persistedFulfillmentOfferings = dataToNormalize.fulfillmentOfferings;
  }
  if (dataToNormalize.availableFulfillmentTypes) {
    dataToNormalize.persistedAvailableFulfillmentTypes = dataToNormalize.availableFulfillmentTypes;
  }
  // MYBAG-4090: Cleanup - End

  const normalized = normalize(dataToNormalize, dataSchema);
  const { result, entities } = normalized || {};
  const { errors, data, ...rest } = entities || {};
  const entitiesToMerge = Object.keys(rest).reduce(
    deepStateMerge({
      state,
      nextState: rest,
      keysToExclude: keysToExcludeFromMerge,
      keysToMergeArrays,
    }),
    {},
  );
  return {
    ...state,
    ...entitiesToMerge,
    result: {
      ...state.result,
      ...(result || {}),
    },
  };
};
